import axios from 'axios'
import store from './store'
//import router from './router'

const axiosplugin = axios.create();

axiosplugin.interceptors.request.use((config) => {
  const user = store.state.user; // probar con dispatch ('getuser')
  if (user) {
    const authToken = user.access_token;
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
  } 
  return config;
}, () => {
    //What do you want to do when a call fails?
    console.log("call failed");
})

axiosplugin.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
// Any status codes that falls outside the range of 2xx cause this function to trigger
// Do something with response error
    if((error.response.status === 401)||(error.response.status === 403)){
        console.log('intercepted unauthorized', store.state.user)
        if(store.state.user !== null)
            store.dispatch('signIn','/monitor')    
        else {
            store.dispatch("authenticate")  
        }
    }/**/
    return Promise.reject(error);
})

export default axiosplugin;